import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  height: "32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "fill-rule": "evenodd" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m20 4 1 1v4h5v2h-1.08l-1.26 15.08-1 .92H9.34l-1-.92L7.09 11H6V9h5V5l1-1zm2.91 7H9.1l1.16 14h11.5l1.16-14zM19 6h-6v3h6z",
    "fill-rule": "nonzero"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m12.8 13 .52 10h-1.5l-.52-10zm3.95 0v10h-1.5V13zm3.95 0-.52 10h-1.5l.52-10z",
    opacity: ".55"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }